module.exports = __webpack_public_path__ + "img/ee.ef471eeb.svg";